export default "__VITE_ASSET__9QNPoq61__"